/**
 * @providesModule @api/User
 */

export * from './UserPersonalInfo';
